import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React from 'react';
import { connect } from "react-redux";
import ClientType from './ClientType/TipoviKlijenata.js'
import Country from './Country/Drzave.js'
import MeansOfPayment from './MeansOfPayment/NaciniPlacanja.js'
import { withNamespaces } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import ExchangeRate from './ExchangeRate/TecajnaLista'

export class TabContainer extends React.Component{
    render(){  
        const { t } = this.props

        let stil = {wordBreak : "normal"}
        if(isMobile){
            stil = {
                wordBreak : "normal",
                width: "fit-content"
            }
        }

        return(
            <div className="dashboardTabsAdmin">
                <Tabs className="codebookTabs">
                    <TabList>
                        <Tab style={stil}>{t('Client Type')}</Tab>                    
                        <Tab style={stil}>{t('Countries')}</Tab>
                        <Tab style={stil}>{t('Means of payment')}</Tab>
                        <Tab style={stil}>{t('Exchange rate')}</Tab>
                    </TabList>
                    <hr className='hr'
                    />
                    <TabPanel>
                        <ClientType />
                    </TabPanel>
                    <TabPanel>
                        <Country />
                    </TabPanel>
                    <TabPanel>
                        <MeansOfPayment />
                    </TabPanel>
                    <TabPanel>
                        <ExchangeRate />
                    </TabPanel>

                </Tabs>
            </div>
        )
    };
};

const mapStateToProps = state => {
    return {      
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(TabContainer));
